module.exports = __webpack_public_path__ + "img/works_ssLife_e_btm_off.28adf1b9.jpg";